import React, { useEffect, useRef, useState } from "react";
import {
  getAxiosResponse,
  putAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import { useSelector } from "react-redux";
import APIUrls from "../../../services/APIUrls";
import Header from "../../../components/global/Header";
import { transformBlankToNull } from "../../../services/Util";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, Link } from "react-router-dom";
import Select from "react-select";
import { border } from "@mui/system";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import {CrossIcon} from "../../../AppIcons";
export default function EditDisabledReviewWorkflow() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const param = useParams();
  const [steps, setSteps] = useState([]);
  const [workflow, setWorkflow] = useState([]);
  const [validationErrors,setValidationErrors]=useState({})
  const [defautSelectedDeparts, setDefaultSelectedDeparts] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [options, setOptions] = useState("");
  const [enableRating, setEnableRating] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState({
    label: "",
    value: "",
  });
  const [hasDepartment, setHasDepartment] = useState(false);
  const editWorkflow = useSelector(
    (updateReviewWorkflow) => updateReviewWorkflow.edit_review_workflow
  ).value;
  const changeStepName = (value, stepIndex) => {
    var copySteps = structuredClone(steps);
    copySteps[stepIndex].name = value;
    setSteps(copySteps);
  };
  const selectDepartments = (value) => {
    if (value.value === "all") {
      departments.map((depart) => {
        if (depart.value !== "all") {
          setDefaultSelectedDeparts((current) => [...current, depart.value]);
        }
      });
      setDepartments([]);
    } else {
      setDefaultSelectedDeparts((current) => [...current, value.value]);
      setDepartments((current) =>
        current.filter((depart) => depart.value.id !== value.value.id)
      );
    }
    setSelectedDepartment(value.value);
  };
  const removeDepartment = (value) => {
    if (departments.length === 1) {
      departments.unshift({ label: "Select - All", value: "all" });
    }
    setDefaultSelectedDeparts((current) =>
      current.filter((depart) => depart.id !== value.id)
    );
    if (value !== "all") {
      setDepartments((current) => [
        ...current,
        { label: value.name, value: value },
      ]);
    }
  };
  const getAllDepartments = (defaultSelected) => {
    getAxiosResponse(APIUrls.ALL_DEPARTMENT)
      .then((res) => {
        if (res.data !== "") {
          var options = [{ label: "Select - All", value: "all" }];
          var result = res.data.data.filter(
            (id1) => !defaultSelected?.some((id2) => id1.id === id2.id)
          );
          result.map((depart) => {
            options.push({
              label: depart.name,
              value: depart,
            });
          });
          setHasDepartment(options.length > 1) // first is "select all" option
          setDepartments(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
  useEffect(() => {
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setOptions(res.data.data);
    });

    getAxiosResponse(APIUrls.GET_WORKFLOW_BY_ID(param.id))
      .then((res) => {
        if (res.data !== "") {
          setWorkflow(res.data.data);
          setEnableRating(res.data.data.enableRating);
          setSteps(res.data.data.steps);
          setDefaultSelectedDeparts(res.data.data.userGroups);
          getAllDepartments(res.data.data.userGroups);
          res.data.data.steps.map((step, stepIndex) => {
            step.phases.map((phase, phaseIndex) => {
              if (phase.isApprovalPhase) {
                getReturnPhases(step, stepIndex, phase, phaseIndex,res.data.data.steps);
              }
            });
          });
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }, []);

  const isFullWorkflowEditEnabled = () => {
    return (
      options?.features?.CUSTOM_WORKFLOW &&
      (!editWorkflow.id || editWorkflow.workflowType.code === "custom")
    );
  };
  const reviewModeEditable = (phase, step, index) => {
    var val =
      phase.phaseNumber !== 1 &&
      index + 1 < step.phases.length &&
      phase.isApprovalPhase !== true
        ? true
        : false;

    if (phase.allowMultiAssignee === true) {
      val = false;
    }
    return val;
  };
 
  const saveWorkflow = () => {
    var copyworkflow = { ...workflow };
    copyworkflow.userGroups = defautSelectedDeparts;
    
    var payload = transformBlankToNull(copyworkflow);
    putAxiosResponse(APIUrls.GET_WORKFLOW_BY_ID(param.id), payload).then(
      (res) => {
        if(res.data.data.body.errors.error){
          setValidationErrors(res.data.data.body.errors)
        }else{
          navigate("/settings/review-workflow");
        }
      }
    );
  };
  const getPhaseName = (step,selectedPhase) =>{
    var returnPhase = step.phases.filter((phase)=>{
        return phase.phaseNumber == selectedPhase.returnPhaseNumber
    })
      return `Phase ${returnPhase[0].phaseNumber} (${returnPhase[0].phaseType.display})`
  }
  const getReturnPhases = (step, stepIndex, phase, phaseIndex) => {
    var copySteps = structuredClone(steps);
    copySteps[stepIndex].phases[phaseIndex].returnPhases = [];

    step.phases.map((previousePhase, index) => {
      if (previousePhase.phaseNumber < phase.phaseNumber) {
        var returnPhase = {
          phaseNumber: previousePhase.phaseNumber,
        };
        if (phase.name !== "") {
          returnPhase.name = previousePhase.name;
        } else {
          returnPhase.name = previousePhase.phaseType.display;
        }
        returnPhase.displayText =
          "Phase " +
          returnPhase.phaseNumber +
          "&nbsp;(" +
          returnPhase.name +
          ")";

        if (
          phase.returnPhaseNumber &&
          phase.returnPhaseNumber === returnPhase.phaseNumber
        ) {
          copySteps[stepIndex].phases[phaseIndex].returnPhaseDisplay =
            returnPhase.displayText;
        }
        copySteps[stepIndex].phases[phaseIndex].returnPhases.push(returnPhase);
      }
      
    });
    return (copySteps);
  };
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Review workflow template', url:'settings/review-workflow'},
    {label:'Disable edit review workflow', url:''},
  ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="project-setting-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button
                    aria-label="back"
                    onClick={() => navigate("/settings/review-workflow")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                    >
                      <path
                        d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                  </button>
                  <span>Return to Review Workflow Templates</span>
                </div>
                <h3 className="flex">Edit {workflow.name}</h3>
                <span>Change your workflow template.</span>
              </div>
              <div className="white-bg">
                <div className="create-new-review-workflow">
                  <div className="wrap-input-text-group mar-bot20">
                    <label>Name</label>
                    <div className="input-text-group flex">
                    {workflow.name}
                    </div>
                  </div>
                  <div className="wrap-input-text-group mar-bot20">
                    <label>Description</label>
                    <div className="input-text-group flex">
                    {workflow.description}
                    </div>
                  </div>
                  <div className="project-heading">
                    <h6>Workflow Steps</h6>
                    <p>
                    </p>
                    {validationErrors.steps ? <p className="error">{validationErrors.steps}</p>: ''}
                  </div>
                  <div className="workflow-wrap flex-align-center setting-review-flow">
                    {steps.map((step, stepIndex) => {
                      return (
                        <React.Fragment key={stepIndex}>
                          <div className="workflow-step-list open-step">
                            <div className="inner-step-list">
                              <input
                                className="step-btn"
                                type="text"
                                disabled = {!isFullWorkflowEditEnabled()}
                                defaultValue={
                                  step.name !== ""
                                    ? step.name
                                    : `Step ${step.stepNumber}`
                                }
                                style={validationErrors['steps.' + stepIndex + '.name'] !== undefined ? {border:"1px solid red"} : {}}
                                onChange={(e) =>
                                  changeStepName(e.target.value, stepIndex)
                                }
                              />
                              <div className="workflow-step-content flex">
                                {step.phases.map((phase, index) => {
                                  return (
                                    <div className="step-box-list" key={index}>
                                      <div className="step-assignee">
                                          <div className="step-assignee flex-center" >
                                              {phase.name !== undefined &&
                                            phase.name !== "" ? (
                                              <span className="phaseName">
                                                {phase.name}
                                              </span>
                                            ) : phase.phaseNumber ===
                                              step.phases.length ? (
                                              <span className="finalPhaseName">
                                                Final Review
                                              </span>
                                            ) : (
                                              <span className="phaseDisplay">
                                                {phase.phaseType.display}
                                              </span>
                                            )}
                                            
                                          </div>
                                      </div>
                                      {isFullWorkflowEditEnabled &&
                                      !(
                                        step.stepNumber === 1 &&
                                        phase.phaseNumber === 1
                                      ) ? (
                                        phase.assigneeType !== "" ? (
                                          <div className="step-assignee">
                                            <div className="step-assignee flex-center" >
                                              <span className="select"
                                              >
                                                {phase.assigneeType !==
                                                  undefined &&
                                                phase.assigneeType !== null
                                                  ? phase?.assigneeType?.display
                                                  : "Assignee"}
                                              </span>
                                            </div>
                                          </div>
                                        ) : (
                                          <span>Error Assignee</span>
                                        )
                                      ) : phase.assigneeType !== "" ? (
                                        <strong>
                                          {phase?.assigneeType?.display}
                                        </strong>
                                      ) : (
                                        <strong>Assignee</strong>
                                      )}
                                      <div className="step-assignee ">
                                        <div className="step-assignee flex-center"
                                          aria-label="Single Assignee"
                                          aria-expanded="false"
                                          tabIndex={!isFullWorkflowEditEnabled() ? -1 : 0}
                                        >
                                          <div className="flex-center width-120">
                                          <span>
                                            {phase.allowMultiAssignee
                                              ? "Multi Assignee"
                                              : "Single Assignee"}
                                          </span>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M8.5 17C10.7704 17 12.905 16.1158 14.5104 14.5104C16.1158 12.905 17 10.7704 17 8.5C17 6.22957 16.1158 4.09504 14.5104 2.48957C12.905 0.884166 10.7704 0 8.5 0C6.22957 0 4.09504 0.884166 2.48957 2.48957C0.884167 4.09504 0 6.22957 0 8.5C0 10.7704 0.884167 12.905 2.48957 14.5104C4.09504 16.1158 6.22957 17 8.5 17ZM8.5 1.32812C12.4546 1.32812 15.6719 4.54541 15.6719 8.5C15.6719 12.4546 12.4546 15.6719 8.5 15.6719C4.54541 15.6719 1.32812 12.4546 1.32812 8.5C1.32812 4.54541 4.54541 1.32812 8.5 1.32812ZM8.5332 9.13086C10.2908 9.13086 11.7207 7.70097 11.7207 5.94336C11.7207 4.18575 10.2908 2.75586 8.5332 2.75586C6.7756 2.75586 5.3457 4.18575 5.3457 5.94336C5.3457 7.70097 6.7756 9.13086 8.5332 9.13086ZM8.5332 4.08398C9.55848 4.08398 10.3926 4.91811 10.3926 5.94336C10.3926 6.96861 9.55848 7.80273 8.5332 7.80273C7.50792 7.80273 6.67383 6.96861 6.67383 5.94336C6.67383 4.91811 7.50792 4.08398 8.5332 4.08398Z" fill="#1D4ED8"></path><path d="M4.74697 13.1484C4.93919 13.1484 5.12977 13.0654 5.26109 12.9052C5.9468 12.068 6.95976 11.5879 8.04026 11.5879H8.82817C9.90866 11.5879 10.9216 12.068 11.6073 12.9052C11.8397 13.1888 12.2581 13.2305 12.5418 12.9981C12.8256 12.7657 12.8672 12.3473 12.6348 12.0636C11.6958 10.9172 10.3083 10.2598 8.82817 10.2598H8.04026C6.5601 10.2598 5.17264 10.9172 4.23365 12.0636C4.00126 12.3473 4.04287 12.7657 4.32662 12.9981C4.45 13.0992 4.59895 13.1484 4.74697 13.1484Z" fill="#1D4ED8"></path></svg>
                                         </div>
                                        </div>
                                      </div>
                                      {phase.phaseType?.originalEnum ===
                                        "REVIEW" ||
                                      phase.phaseType?.type === "REVIEW" ? (
                                        <div className="step-assignee">
                                          {phase.isApprovalPhase ? (
                                           <div className="step-assignee flex-center">
                                              <span>Approval</span>
                                            </div>
                                          ) : (
                                            <div className="step-assignee flex-center">
                                              <span>Review</span>
                                            </div>
                                          )}
                                        </div>
                                      ) : null}
                                      {phase.isApprovalPhase ? (
                                        <>
                                          <span>Phase on rejection :</span>
                                          <div className="step-assignee">
                                            <div className="step-assignee flex-center">
                                              {phase.returnPhaseNumber !== '' ? getPhaseName(step,phase) : 
                                              <span
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  phase.returnPhaseDisplay
                                                    ? phase.returnPhaseDisplay
                                                    : phase?.returnPhases?.length > 0 ? phase?.returnPhases[0]?.displayText : null,
                                              }}
                                            ></span>
                                              }
                                              <svg
                                                className="dropdown-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V10.293L5.354 8.146C5.26011 8.05211 5.13278 7.99937 5 7.99937C4.86722 7.99937 4.73989 8.05211 4.646 8.146C4.55211 8.23989 4.49937 8.36722 4.49937 8.5C4.49937 8.63278 4.55211 8.76011 4.646 8.854L7.646 11.854C7.69245 11.9006 7.74762 11.9375 7.80837 11.9627C7.86911 11.9879 7.93423 12.0009 8 12.0009C8.06577 12.0009 8.13089 11.9879 8.19163 11.9627C8.25238 11.9375 8.30755 11.9006 8.354 11.854L11.354 8.854C11.4479 8.76011 11.5006 8.63278 11.5006 8.5C11.5006 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.5 10.293V4.5Z"
                                                  fill="#1D4ED8"
                                                ></path>
                                              </svg>
                                            </div>
                                           
                                          </div>
                                        </>
                                      ) : null}
                                      {isFullWorkflowEditEnabled &&
                                      reviewModeEditable(phase, step, index) &&
                                      phase.phaseType.display !==
                                        "Approval Only" ? (
                                        <div className="step-assignee">
                                           <div className="step-assignee flex-center">
                                            <span>Permissions</span>
                                            <svg
                                              className="dropdown-icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              viewBox="0 0 16 16"
                                              fill="none"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V10.293L5.354 8.146C5.26011 8.05211 5.13278 7.99937 5 7.99937C4.86722 7.99937 4.73989 8.05211 4.646 8.146C4.55211 8.23989 4.49937 8.36722 4.49937 8.5C4.49937 8.63278 4.55211 8.76011 4.646 8.854L7.646 11.854C7.69245 11.9006 7.74762 11.9375 7.80837 11.9627C7.86911 11.9879 7.93423 12.0009 8 12.0009C8.06577 12.0009 8.13089 11.9879 8.19163 11.9627C8.25238 11.9375 8.30755 11.9006 8.354 11.854L11.354 8.854C11.4479 8.76011 11.5006 8.63278 11.5006 8.5C11.5006 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.5 10.293V4.5Z"
                                                fill="#1D4ED8"
                                              ></path>
                                            </svg>
                                          </div>
                                         
                                        </div>
                                      ) : phase.phaseType.originalEnum ===
                                        "REVIEW" ? (
                                        phase.allowRevision === true ? (
                                          <div className="step-request">
                                            <span className="revision-allowed pl-0">
                                              Can Request Revision
                                            </span>
                                            <div className="left-icon">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 64 64"
                                                width="30"
                                                height="23"
                                              >
                                                <path
                                                  d="M 22 12 C 16.486 12 12 16.486 12 22 L 12 23 C 12 24.104 12.896 25 14 25 C 15.104 25 16 24.104  16 23 L 16 22 C 16 18.691 18.691 16 22 16 L 42 16 C 45.309 16 48 18.691 48 22 L 48 24 L 45.107422 24 C  44.213422 24 43.685313 25.003281 44.195312 25.738281 L 49.089844 32.8125 C 49.529844 33.4495 50.471109  33.4495 50.912109 32.8125 L 55.806641 25.738281 C 56.314641 25.003281 55.788531 24 54.894531 24 L 52 24 L  52 22 C 52 16.486 47.514 12 42 12 L 22 12 z M 14 30.708984 C 13.654375 30.708984 13.308391 30.869 13.087891  31.1875 L 8.1953125 38.261719 C 7.6873125 38.996719 8.2134219 40 9.1074219 40 L 12 40 L 12 42 C 12 47.514  16.486 52 22 52 L 42 52 C 47.514 52 52 47.514 52 42 L 52 41 C 52 39.896 51.104 39 50 39 C 48.896 39 48  39.896 48 41 L 48 42 C 48 45.309 45.309 48 42 48 L 22 48 C 18.691 48 16 45.309 16 42 L 16 40 L 18.892578  40 C 19.786578 40 20.314688 38.996719 19.804688 38.261719 L 14.910156 31.1875 C 14.690156 30.869 14.345625  30.708984 14 30.708984 z"
                                                  fill="#1D4ED8"
                                                ></path>
                                              </svg>
                                            </div>
                                            
                                          </div>
                                        ) : (
                                          <div className="step-request">
                                            <div className="left-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none"><path d="M13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967L8.75736 0.696699C8.46447 0.403806 7.98959 0.403806 7.6967 0.696699C7.40381 0.989593 7.40381 1.46447 7.6967 1.75736L11.9393 6L7.6967 10.2426C7.40381 10.5355 7.40381 11.0104 7.6967 11.3033C7.98959 11.5962 8.46447 11.5962 8.75736 11.3033L13.5303 6.53033ZM0 6.75H13V5.25H0V6.75Z" fill="#1D4ED8"></path></svg>
                                            </div>
                                            <span>Cannot Request Revision</span>
                                          </div>
                                        )
                                      ) : phase.phaseType.originalEnum ===
                                        "WORK" ? (
                                          <div className="step-request">
                                          <div className="left-icon">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none"><path d="M13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967L8.75736 0.696699C8.46447 0.403806 7.98959 0.403806 7.6967 0.696699C7.40381 0.989593 7.40381 1.46447 7.6967 1.75736L11.9393 6L7.6967 10.2426C7.40381 10.5355 7.40381 11.0104 7.6967 11.3033C7.98959 11.5962 8.46447 11.5962 8.75736 11.3033L13.5303 6.53033ZM0 6.75H13V5.25H0V6.75Z" fill="#1D4ED8"></path></svg>
                                          </div>
                                          <span>Cannot Request Revision</span>
                                        </div>
                                      ) : null}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                            
                          </div>
                          <div style={{minWidth:"40px"}}></div>
                        </React.Fragment>
                      );
                    })}

                    
                  </div>
                  {hasDepartment &&
                      <div className="department-block mar-bot30">
                        <h6>Departments</h6>
                        <p>Which departments can use this workflow?</p>
                        <div className="flex wrap-dropdown mb-0">
                          <div className="global-dropdown-block">
                            <Select
                                classNamePrefix="cw"
                                className="global-dropdown-select"
                                value={departments.filter(function (option) {
                                  if(selectedDepartment.value !== ""){
                                    return option.value.id === selectedDepartment?.id;
                                  }
                                })}
                                aria-label="Departments"
                                placeholder={"Select Department"}
                                options={departments}
                                onChange={(e) => selectDepartments(e)}
                                menuShouldScrollIntoView={false}
                                closeMenuOnSelect={true}
                            />
                          </div>
                        </div>
                        {validationErrors.userGroups ? <p className="error">{validationErrors.userGroups}</p> : ''}
                        <div className="multiselect-output flex">
                          <div>
                            {defautSelectedDeparts.map((depart, index) => {
                              return (
                                  <button
                                      key={index}
                                      onClick={() => removeDepartment(depart)}
                                  >
                                    <strong>{depart.name}</strong>

                                    {CrossIcon}
                                  </button>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
          <div>
            <button className="btn-default" onClick={()=>navigate("/settings/review-workflow")}>Cancel</button>
          </div>
          {/* {options?.features?.ENABLE_LANGUAGE_REVIEWER_TEMPLATE && defautSelectedDeparts.length > 0 ?  <div>
            <button className="btn-default" onClick={()=>navigate(`/settings/workflow/language-review-workflow/${param.id}`)}>Add Language Reviewers</button>
          </div>  : null} */}
         

          <div>
            {hasDepartment && <button className="btn-default" onClick={saveWorkflow}>
              Save
            </button>}

          </div>
        </div>
      </div>
    </div>
  );
}
